<template>
  <div>
    <Header @toggleSidebar="toggle" :notification="notification_text ? true : false" v-if="!$route.meta.hideHeader && !$store.getters.getGLoading" class="sticky-top"/>
    <div class="app-body">
      <sidebar :hide="sideHide" :notification="notification_text ? true : false" v-if="!$route.meta.hideSidebar && !$store.getters.getGLoading" class="sticky-top sticky-offset" />
      <div class="notice" v-if="notification_text">
        <div class="notice__title">
          <img src="../assets/icons/warning.svg" alt="">
            {{notification_title}}
        </div>
        <div class="notice__text" v-html="notification_text">
        </div>
      </div>
      <div style="    width: 100%;" v-if="Object.keys(banners).length > 0">
        <div class="mcard" style="    max-height: 260px;
    overflow: hidden;
    display: flex;
    padding: 35px;
    align-items: center;
    justify-content: space-between;
    position: relative;">
          <span class="banner_btn" @click="prevBanner">	&#60;</span>
          <span class="banner_btn" @click="nextBanner" style="    right: 36px;">&#62;</span>
          <a :href="banners[banner].url"> <img style="width: 100%;height: 100%;object-fit: cover;" :src="banners[banner].path"></a>

        </div>
        <router-view :key="$route.name"/>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Sidebar from "@/components/sidebar";

export default {
  name: "mainLayout",
  components: { Header, Sidebar },
  data: ()=> ({
    sideHide: false,
    notification_text: '',
    notification_title: '',
    banner: 0,
    banners: []
  }),
  mounted() {
    this.getGlobalNotification();

    this.$http.post('/get-banner', {
      type:2,
    }).then(({data})=> {
      this.banners = data
    });
  },
  methods :{
    prevBanner() {
      if(this.banner === 0) {
        this.banner = Object.keys(this.banners).length - 1
      } else {
        this.banner--
      }
    },
    nextBanner() {
      if(this.banner === Object.keys(this.banners).length - 1) {
        this.banner = 0
      } else {
        this.banner++
      }
    },
    toggle(){
      this.sideHide = !this.sideHide
    },
    getGlobalNotification() {
      this.$http.post('/get-global-notification', {
        token: localStorage.getItem('token')
      }).then(({data}) => {
        if (data.notification) {
            this.notification_text = data.notification.description;
            this.notification_title = data.notification.title;
        }
      }).catch((error) => {
          console.log(error)
      })
    },
  }
}
</script>

<style scoped lang="scss">
  .notice{
    position: absolute;
    top: 60px;
    left: 235px;
    right: 35px;
    background: #FFFFFF;
    border: 1px solid #F39220;
    box-sizing: border-box;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    padding: 20px;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #2D3137;
    &__title{
       display: flex;
       align-items: center;
       margin-bottom: 10px;
      img{
        margin-right: 10px;
      }
    }
    &__text{
       font-weight: normal;
       font-size: 12px;
       line-height: 14px;
       color: #636974;
     }
  }
  .banner_btn {
    position: absolute;
    background-color: #0000006b;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    border-radius: 50%;
  }
  .banner_btn:hover {
    cursor: pointer;
  }
</style>
